export type PhotoTransform = {
  scale: number;
  offsetX: number;
  offsetY: number;
};

export const FRAME_SIZE = 168;
export const OUTPUT_SIZE = 200;
export const MIN_ZOOM_PERCENT = 50;
export const MAX_ZOOM_PERCENT = 400;

export const getInitialCoverScale = (
  naturalWidth: number,
  naturalHeight: number,
  frameSize: number = FRAME_SIZE
): number =>
  Math.max(frameSize / naturalWidth, frameSize / naturalHeight);

export const clampOffsets = (
  naturalWidth: number,
  naturalHeight: number,
  scale: number,
  offsetX: number,
  offsetY: number,
  frameSize: number = FRAME_SIZE
): PhotoTransform => {
  const imgW = naturalWidth * scale;
  const imgH = naturalHeight * scale;
  const maxOffsetX = Math.max(0, (imgW - frameSize) / 2);
  const maxOffsetY = Math.max(0, (imgH - frameSize) / 2);
  return {
    scale,
    offsetX: Math.min(maxOffsetX, Math.max(-maxOffsetX, offsetX)),
    offsetY: Math.min(maxOffsetY, Math.max(-maxOffsetY, offsetY)),
  };
};

export const renderCroppedPhoto = (
  image: HTMLImageElement,
  transform: PhotoTransform,
  frameSize: number = FRAME_SIZE,
  outputSize: number = OUTPUT_SIZE
): string | null => {
  const canvas = document.createElement('canvas');
  canvas.width = outputSize;
  canvas.height = outputSize;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  const ratio = outputSize / frameSize;
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, outputSize, outputSize);
  ctx.save();
  ctx.translate(
    outputSize / 2 + transform.offsetX * ratio,
    outputSize / 2 + transform.offsetY * ratio
  );
  ctx.scale(transform.scale * ratio, transform.scale * ratio);
  ctx.drawImage(
    image,
    -image.naturalWidth / 2,
    -image.naturalHeight / 2,
    image.naturalWidth,
    image.naturalHeight
  );
  ctx.restore();
  try {
    return canvas.toDataURL('image/jpeg', 0.88);
  } catch {
    return null;
  }
};
